export default __webpack_public_path__ + "static/media/a444e7f9dbef18eec0899043392018341600889666781.1fbefda2.webp";